import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles
} from '@material-ui/core';
import React from 'react';
import { withRouter } from 'react-router';
import { compose } from 'recompose';

const enhance = compose();
const useStyles = makeStyles({
  paperWidthSm: {
    maxWidth: 325
  },
  title: {
    fontSize: 24,
    fontWeight: 500
  },
  message: {
    fontSize: 16,
    color: '#808080',
    marginBottom: 30,
    textAlign: 'center'
  },
  contentConfirm: {
    fontSize: 16,
    color: '#7DB750',
    marginBottom: 20,
    textAlign: 'center'
  },
  contentDescription: {
    fontSize: 16,
    marginBottom: 20,
    color: '#222222',
    textAlign: 'center'
  },
  buttonLarge: {
    minWidth: 186,
    minHeight: 48,
    fontSize: 14
  },
  buttonLargeGrey: {
    minWidth: 186,
    minHeight: 48,
    fontSize: 14,
    color: '#808080'
  }
});

const Main = enhance(
  ({
    budgetRowDetail,
    budgetAmount,
    cancelAction,
    isOpen,
    okAction,
    message,
    contentConfirm,
    title,
    children,
    revert,
    textOk,
    textCancel
  }) => {
    const classes = useStyles();
    function monthToStr(m) {
      return m < 10 ? `0${m}` : m;
    }
    return (
      <Dialog open={isOpen} onClose={cancelAction} className="dialog-custom">
        <DialogTitle>
          <div className={classes.title}>{title}</div>
        </DialogTitle>
        <DialogContent>
          {message && (
            <DialogContentText
              id="alert-dialog-description"
              className={classes.message}
            >
              {message}
            </DialogContentText>
          )}

          {children}

          {contentConfirm && (
            <DialogContentText
              id="alert-dialog-description"
              className={classes.contentConfirm}
            >
              {contentConfirm}
            </DialogContentText>
          )}

          {budgetRowDetail && (
            <DialogContentText
              id="alert-dialog-description"
              className={classes.contentDescription}
            >
              {monthToStr(budgetRowDetail.budgetMonth)}
              月の予算を確定します。
              <br />
              下記金額でお間違いないでしょうか。
              <br />
              {budgetAmount ? parseInt(budgetAmount, 0).toLocaleString() : 0}
              {'円'}
            </DialogContentText>
          )}

          {!revert ? (
            <DialogActions className="mb-3">
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonLarge}
                onClick={okAction}
              >
                {textOk || '削除'}
              </Button>
              <Button
                variant="contained"
                // color="secondary"
                className={classes.buttonLargeGrey}
                onClick={cancelAction}
              >
                {textCancel || 'キャンセル'}
              </Button>
            </DialogActions>
          ) : (
            <DialogActions className="mb-3">
              <Button
                variant="contained"
                // color="secondary"
                className={classes.buttonLargeGrey}
                onClick={cancelAction}
              >
                {textCancel || 'キャンセル'}
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonLarge}
                onClick={okAction}
              >
                {textOk || '削除'}
              </Button>
            </DialogActions>
          )}
        </DialogContent>
      </Dialog>
    );
  }
);

export default withRouter(Main);
